import {
  BorderBottomOutlined,
  BorderHorizontalOutlined,
  BorderLeftOutlined,
  BorderRightOutlined,
  BorderTopOutlined,
  BorderVerticleOutlined,
  ColumnHeightOutlined,
  ColumnWidthOutlined,
} from "@ant-design/icons";
import { Radio, RadioProps, Space } from "antd";
import React from "react";

export const AnchorSelect = (props: RadioProps) => {
  return (
    <Radio.Group {...props}>
      <Space direction="vertical" align="center">
        <Space.Compact direction="horizontal">
          <Radio.Button value="ANCHOR_LEFT">
            <BorderLeftOutlined  /> Left
          </Radio.Button>
          <Radio.Button value="ANCHOR_TOP">
            <BorderTopOutlined  /> Top
          </Radio.Button>
          <Radio.Button value="ANCHOR_RIGHT">
            <BorderRightOutlined  /> Right
          </Radio.Button>
        </Space.Compact>
        <Space.Compact direction="horizontal">
          <Radio.Button value="ANCHOR_BOTTOM">
            <BorderBottomOutlined  /> Bottom
          </Radio.Button>
          <Radio.Button value="ANCHOR_CENTER_X">
            <BorderHorizontalOutlined  /> Center X
          </Radio.Button>
          <Radio.Button value="ANCHOR_CENTER_Y">
            <BorderVerticleOutlined  /> Center Y
          </Radio.Button>
        </Space.Compact>
        <Space.Compact direction="horizontal">
          <Radio.Button value="ANCHOR_WIDTH">
            <ColumnWidthOutlined  /> Width
          </Radio.Button>
          <Radio.Button value="ANCHOR_HEGIHT">
            <ColumnHeightOutlined  /> Height
          </Radio.Button>
        </Space.Compact>
      </Space>
    </Radio.Group>
  );
};
